import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Vue from 'vue'
import translation from '@/mixins/translate'

const notification = {
  mixins: [translation],
  methods: {
    error(title = `${this.$tk('Toast.Error')}`, text = '') {
      Vue.$toast({
        component: ToastificationContent,
        props: {
          title,
          text,
          icon: 'BellIcon',
          variant: 'danger',
        },
      })
    },
    success(title = `${this.$tk('Toast.Success')}`, text = '') {
      Vue.$toast({
        component: ToastificationContent,
        props: {
          title,
          text,
          icon: 'BellIcon',
          variant: 'success',
        },
      })
    },
  },
}
export default notification
